export const processStatus = {
  NoError: 0,
  NoElement: 1,
  ReadOnly: 2,
  NotMatched: 3,
  NotRecog: 4,
};
